<script lang="ts" setup>
import Card from 'primevue/card'
import Select from 'primevue/select'
import InputText from 'primevue/inputtext'
import FloatLabel from 'primevue/floatlabel'
import Button from 'primevue/button'
import Message from 'primevue/message'
import { Form, FormField } from '@primevue/forms'
import { AVAILABLE_DEXCHANGES, AVAILABLE_GMGN_CHAINS } from '@/utils/consts'
import { watch, ref, useTemplateRef, onMounted } from 'vue'
import { zodResolver } from '@primevue/forms/resolvers/zod'
import { i18n } from '@/i18n'
import { z } from 'zod'
import type { FormSubmitEvent } from '@primevue/forms'
import { useAuthStore } from '@/stores/authStore'
import { useThemeStore } from '@/stores/themeStore'
import type { FormInstance } from '@primevue/forms'
// import { useAssetsStore } from '@/stores/assetsStore'
// import type { AssetExchangeContractMinResponse } from '@/services/assets-v2-service/types'
import { useRouter } from 'vue-router'
import AddTokenContractModal from '@/components/modals/addTokenContractModal.vue'
import { useAssetsStore } from '@/stores/assetsStore'

const { t } = i18n.global
const loading = ref(true)
// const contracts = ref<AssetExchangeContractMinResponse[]>([])
// const assetsStore = useAssetsStore()
const themeStore = useThemeStore()
const authStore = useAuthStore()
const router = useRouter()
const assetsStore = useAssetsStore()

const addTokenModal = useTemplateRef("addTokenModal")
const form = useTemplateRef<FormInstance>('form')
const initValues = {
  asset: '',
  cex: 'mexc',
  chain: '',
}

const resolver = zodResolver(
  z.object({
    asset: z.string().min(1, { message: t('assetEmptyError') }),
    cex: z.string().min(1, { message: t('cexEmptyError') }),
    chain: z.string().min(1, { message: t('chainEmptyError') }),
  }),
)

const onFormSubmit = (e: FormSubmitEvent) => {
  if (!e.valid) {
    return
  }
  loading.value = true
  window.setTimeout(() => {
    const routeData = router.resolve({
      name: 'eye-dex-asset-long',
      params: {
        marketType: 'swap',
        asset: e.values.asset.split('/')[0],
        cex: e.values.cex,
        chain: e.values.chain,
      },
    })
    window.open(routeData.href, '_blank')
    loading.value = false
  }, 200)
}

watch(
  () => authStore.currentAccessList,
  (v) => {
    if (!('dex_cex' in v || 'dex_cex_free' in v || 'dex_cex_advanced' in v)) {
      themeStore.forbidden = true
      return
    }
  },
)



onMounted(async () => {
  loading.value = false
  await assetsStore.fetchMyContracts()
})
</script>

<template>
  <Card>
    <template #content>
      <AddTokenContractModal :loading ref="addTokenModal"></AddTokenContractModal>

      <Form ref="form" class="grid p-2 grid-cols-1 lg:grid-cols-8 gap-3" :initial-values="initValues" :resolver
        @submit="onFormSubmit">



        <!-- Биржа CEX -->
        <FormField v-slot="$field" name="cex" class="col-span-2">
          <FloatLabel variant="on">
            <Select :disabled="loading" :loading="loading" fluid :options="AVAILABLE_DEXCHANGES" option-label="title"
              option-value="value"></Select>
            <label>{{ $t('cex') }}</label>
          </FloatLabel>
          <Message v-if="$field?.invalid" severity="error" size="small" variant="simple">{{ $t($field.error?.message) }}
          </Message>
        </FormField>

        <!-- Торговая пара -->
        <FormField v-slot="$field" name="asset" class="relative col-span-2">
          <FloatLabel variant="on">
            <InputText :disabled="loading" fluid autocomplete="off" />
            <label>{{ $t('symbol') }}</label>
          </FloatLabel>
          <Message class="absolute" v-if="$field?.invalid" severity="error" size="small" variant="simple">{{
            $t($field.error?.message) }}
          </Message>
        </FormField>

        <!-- Сеть -->
        <FormField v-slot="$field" name="chain" class="relative col-span-2">
          <FloatLabel variant="on">
            <Select :disabled="loading" :loading="loading" :options="AVAILABLE_GMGN_CHAINS" fluid>
              <template #empty>{{ $t('emptyMessage') }}</template>
            </Select>
            <label>{{ $t('chain') }}</label>
          </FloatLabel>
          <Message class="absolute" v-if="$field?.invalid" severity="error" size="small" variant="simple">{{
            $t($field.error?.message) }}
          </Message>
        </FormField>

        <Button :loading="loading" fluid :disabled="loading" type="submit" severity="secondary" size="small"
          class="col-span-1 w-full" icon="pi pi-link" label=""></Button>

        <Button v-tooltip="$t('tooltip.addContract')" icon="pi pi-address-book" class="col-span-1 w-full" size="small"
          severity="secondary" @click="addTokenModal?.toggle()"></Button>

      </Form>
    </template>
  </Card>
</template>
